export default __webpack_public_path__ + "static/media/DK_Layout_4.a2fc0b85.png";